import { RECOLLECTION_STEP_PATHS } from '@/constants';

import Applicant from '@/containers/recollection/Applicant';
import Ceo from '@/containers/recollection/Ceo';
import UltimateBeneficialOwner from '@/containers/recollection/UltimateBeneficialOwner';
import { STAKEHOLDER_ROLES_V2 } from '@/containers/withStakeholderLogic';

import { or, not } from '@/flow/common';
import {
  hasControlOverManagement,
  hasUltimateBeneficialOwner,
} from '@/flow/configs/selectors/recollection';

export class StakeholderBlock {
  static selectors = {
    hasControlOverManagement,
    hasUltimateBeneficialOwner,
  };

  getSelectors() {
    return StakeholderBlock.selectors;
  }

  generateNextForPreviousStep() {
    return [
      {
        condition: true,
        path: RECOLLECTION_STEP_PATHS.UBO_PATH,
      },
    ];
  }

  generateBackForNextStep() {
    return [
      {
        condition: true,
        path: RECOLLECTION_STEP_PATHS.APPLICANT_PATH,
      },
    ];
  }

  generateFlowConfig({ next, back: rawBack }) {
    const back = typeof rawBack === 'string' ? [{ condition: true, path: rawBack }] : rawBack;

    return [
      {
        id: 'ultimate-beneficial-owner',
        path: RECOLLECTION_STEP_PATHS.UBO_PATH,
        prerequisite: false,
        Container: UltimateBeneficialOwner,
        back,
        next: [
          {
            condition: 'hasUltimateBeneficialOwner',
            path: RECOLLECTION_STEP_PATHS.APPLICANT_PATH,
          },
          {
            condition: not('hasUltimateBeneficialOwner'),
            path: RECOLLECTION_STEP_PATHS.CEO_PATH,
          },
        ],
        extraProps: {
          defaultRole: STAKEHOLDER_ROLES_V2.ULTIMATE_BENEFICIAL_OWNER,
          cantHaveRoles: [
            STAKEHOLDER_ROLES_V2.CONTROL_OVER_MANAGEMENT,
            STAKEHOLDER_ROLES_V2.PARTNER,
          ],
          roleConstraints: 'defaultRoleConstraints',
        },
      },
      {
        id: 'ceo',
        path: RECOLLECTION_STEP_PATHS.CEO_PATH,
        prerequisite: not('hasUltimateBeneficialOwner'),
        Container: Ceo,
        back: RECOLLECTION_STEP_PATHS.UBO_PATH,
        next: RECOLLECTION_STEP_PATHS.APPLICANT_PATH,
        extraProps: {
          defaultRole: STAKEHOLDER_ROLES_V2.CONTROL_OVER_MANAGEMENT,
          roleConstraints: {
            [STAKEHOLDER_ROLES_V2.CONTROL_OVER_MANAGEMENT]: {
              min: 1,
              max: 1,
            },
          },
        },
      },
      {
        id: 'applicant',
        path: RECOLLECTION_STEP_PATHS.APPLICANT_PATH,
        prerequisite: or('hasUltimateBeneficialOwner', 'hasControlOverManagement'),
        Container: Applicant,
        back: [
          {
            condition: 'hasControlOverManagement',
            path: RECOLLECTION_STEP_PATHS.CEO_PATH,
          },
          {
            condition: true,
            path: RECOLLECTION_STEP_PATHS.UBO_PATH,
          },
        ],
        next,
        extraProps: {
          defaultRole: STAKEHOLDER_ROLES_V2.APPLICANT,
          overrideStakeholders: true,
          roleConstraints: {
            [STAKEHOLDER_ROLES_V2.APPLICANT]: {
              min: 1,
            },
          },
        },
      },
    ];
  }
}
